import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CustomInput from 'components/CustomInput/CustomInput';
import InputAdornment from '@material-ui/core/InputAdornment';
import withStyles from '@material-ui/core/styles/withStyles';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import customInputStyle from './style/customInputStyle';

class CustomPasswordInput extends Component {
  state = {
    password: {
      enabled: true,
      visible: false,
    },
    type: 'password',
    value: '',
    inputProps: {},
  };

  async componentDidMount() {
    const { inputProps } = this.props;
    const { type } = this.state;

    await this.setState((prevState) => ({
      ...prevState,
      password: {
        ...prevState.password,
        enabled: type === 'password',
      },
      inputProps: {
        ...inputProps,
        type,
      },
    }));
  }

  togglePasswordVisible() {
    const newVal = !this.state.password.visible;
    const type = newVal ? 'text' : 'password';
    this.setState((prevState) => ({
      ...prevState,
      password: {
        ...prevState.password,
        visible: newVal,
      },
      type,
      inputProps: {
        ...prevState.inputProps,
        type,
      },
    }));
  }

  render() {
    const { classes } = this.props;
    let { password, inputProps } = this.state;

    inputProps = {
      ...inputProps,
      endAdornment: (
        <InputAdornment position='end' className={classes.passwordEyeWrapper}>
          {password.enabled &&
            (password.visible ? (
              <VisibilityOffIcon className={classes.passwordEye} onClick={() => this.togglePasswordVisible()} />
            ) : (
              <VisibilityIcon className={classes.passwordEye} onClick={() => this.togglePasswordVisible()} />
            ))}
        </InputAdornment>
      ),
    };

    return <CustomInput {...this.props} inputProps={inputProps} />;
  }
}

CustomPasswordInput.propTypes = {
  classes: PropTypes.object.isRequired,
  value: PropTypes.string,
  labelText: PropTypes.node,
  labelProps: PropTypes.object,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  formControlProps: PropTypes.object,
  error: PropTypes.bool,
  success: PropTypes.bool,
  helpText: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.bool]),
  transparent: PropTypes.bool,
};

CustomPasswordInput.defaultProps = {};

export default withStyles(customInputStyle)(CustomPasswordInput);
